export default __webpack_public_path__ + "static/media/line-v-12.e4a357a6.png";